import { api } from './_client';
import type { FlightLinksResponse, FlightLinkWriteResponse } from '../../types/api';

/**
 * Link a `.bin` log to its flight record (#1694).
 *
 * `/api/file-objects/{object_id}/flight-links`, addressed by the log's registry
 * id. Org-admin only on the backend, like granting a share: linking a log to a
 * shared flight hands the log to that flight's grantees.
 */
export const flightLinksApi = {
  /** The log's current links, and the flights it may belong to. */
  async getFlightLinks(objectId: string, day?: string): Promise<FlightLinksResponse> {
    const qs = day ? `?day=${encodeURIComponent(day)}` : '';
    const response = await api.get<FlightLinksResponse>(
      `/api/file-objects/${objectId}/flight-links${qs}`
    );
    return response.data;
  },

  async linkFlight(objectId: string, flightId: string): Promise<FlightLinkWriteResponse> {
    const response = await api.post<FlightLinkWriteResponse>(
      `/api/file-objects/${objectId}/flight-links`,
      { flight_id: flightId }
    );
    return response.data;
  },

  async unlinkFlight(objectId: string, flightId: string): Promise<FlightLinkWriteResponse> {
    const response = await api.delete<FlightLinkWriteResponse>(
      `/api/file-objects/${objectId}/flight-links/${flightId}`
    );
    return response.data;
  },
};
